<template>
  <div class="card mb-4">
    <div class="card-header pb-0">
      <h6>Prospectos FTD</h6>
    </div>
    <div class="card-body px-4">
      <div class="table-responsive">
        <div class="d-flex justify-content-between">
          <div class="w-25">
            <select name="per_page" id="per_page" v-model="pagination.limit" class="form-control" @click="reloadPaginate(1)">
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="200">200</option>
            </select>
          </div>
          <div class="w-25">
            <input type="text" class="form-control" placeholder="Escribe para buscar por correo o nombre" v-model="pagination.search" @keyup="manualSearch">
          </div>
        </div>
        <table class="table table-bordered align-items-center table-sm">
          <thead>
          <tr>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Nombre</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Correo electrónico</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">FTD</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Retención</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">País</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Campaña</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Estado</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Opciones</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, key) in arrayUsers" :key="key">
            <td>
              <p class="text-uppercase text-xs font-weight-bold mb-0">{{item.name}}</p>
            </td>
            <td>
              <p class="text-uppercase text-xs font-weight-bold mb-0">{{item.email}}</p>
            </td>
            <td>
              <p class="text-uppercase text-xs font-weight-bold mb-0">
                <span v-if="item.agent_ftd">
                  {{item.agent_ftd.name}} - {{item.agent_ftd.email}}
                </span>
              </p>
            </td>
            <td>
              <p class="text-uppercase text-xs font-weight-bold mb-0">
                <span v-if="item.agent_retention">
                  {{item.agent_retention.name}} - {{item.agent_retention.email}}
                </span>
              </p>
            </td>
            <td>
              <p class="text-xs font-weight-bold mb-0">{{item.country}}</p>
            </td>
            <td>
              <p class="text-xs font-weight-bold mb-0">{{item.campaign }}</p>
            </td>
            <td>
              <p class="text-xs font-weight-bold mb-0">{{item.status?'ACTIVO':'INACTIVO'}}</p>
            </td>
            <td>
              <p class="text-xs font-weight-bold mb-0">{{$filters.formatDate(item.created_at)}}</p>
            </td>
            <td class="">
              <button class="btn btn-success btn-sm" @click="vieDetail(item)">Ver</button>
            </td>
          </tr>
          </tbody>
        </table>
        <div class="d-flex justify-content-between">
          <div>
            <p class="text-xs font-weight-bold mb-0">Total de filas: {{pagination.totalRows}}</p>
          </div>
          <div>
            <v-pagination
                v-model="pagination.page"
                :pages="pagination.pages"
                :range-size="1"
                active-color="#DCEDFF"
                @update:modelValue="reloadPaginate"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {get, post} from "@/utils/httpRequest";
export default {
  name: "index",
  data: () => ({
    arrayUsers: [],
    pagination: {
      searchTimer: null,
      page: 1,
      pages: 0,
      limit: 20,
      search: '',
      totalRows: 0
    }
  }),
  mounted() {
    this.getData()
  },
  methods: {

    reloadPaginate(page){
      this.pagination.page = page
      this.getData()
    },
    manualSearch(){
      clearTimeout(this.pagination.searchTimer);
      this.pagination.searchTimer = setTimeout(() => {
        this.reloadPaginate(1)
      }, 2000);
    },

    async getData(){
      const {data} = await get(`users/find-all-leads-ftd?page=${this.pagination.page}&limit=${this.pagination.limit}&search=${this.pagination.search}&agent=true` )
      this.arrayUsers = data.docs
      this.pagination.totalRows = data.count
      this.pagination.page = data.page
      this.pagination.pages = data.pages
    },

    async remove(item){
      this.$swal({
        html: '¿Estás seguro?',
        showDenyButton: true,
        confirmButtonText: 'Sí',
        cancelButtonText: `No`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          await post("users/remove", {_id: item._id}, true)
          this.$swal({
            html: 'Procesado con éxito',
            icon: 'success',
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false,
          });
          await this.reloadPaginate(1)
        }
      })
    },
    vieDetail(item){
      this.$router.push({name:'users-view', query: {id: item._id}})
    }
  },
}
</script>
<style scoped></style>
